import React from 'react';

class PlayersCountNoNum extends React.Component {
  render() {
    return <div className="game__count">{this.props.label}: {this.props.totalPlayersNum}</div>
  }
}

export default PlayersCountNoNum;
